import { render, staticRenderFns } from "./ANZSEPARATOR.vue?vue&type=template&id=9607d0f2"
import script from "./ANZSEPARATOR.vue?vue&type=script&lang=js"
export * from "./ANZSEPARATOR.vue?vue&type=script&lang=js"
import style0 from "./ANZSEPARATOR.vue?vue&type=style&index=0&id=9607d0f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports